import { call, put, select } from 'redux-saga/effects';
import FrontSonda from '@gcloud-npm/utils.monitoring.front-sonda';
import {
  checkFinancedPaymentStatusLoopGenerator as checkFinancedPaymentStatusLoopGeneratorAda,
} from '@bitComponents/adabyron/payment';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* checkFinancedPaymentStatusLoopGenerator(params) {
  const {
    normalizeHttpErrors,
    reduxUpdate,
  } = params;
  try {
    const context = yield select(contextStore);
    const response = yield call(checkFinancedPaymentStatusLoopGeneratorAda, params, context);
    const { urlSupplier } = response;
    if (!urlSupplier) {
      const errorMsg = 'No se ha podido recuperar la url de la financiera';
      const frontSonda = new FrontSonda({
        processName: 'fundedPayment',
        context,
        filePath: 'sagas/payment',
      });
      frontSonda.errorMessage({ info: errorMsg, error: null });
    }
    return response;
  } catch (error) {
    console.log('error', error);
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.CHECK_FINANCED_PAYMENT_STATUS, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
